/**
 * Short label for team-member chat list / last-message preview (never raw media URLs).
 * @param {object} messageLike - { messageType?, type?, message?, content?, body? }
 * @returns {string}
 */
export function getTeamMemberMessagePreviewLabel(messageLike) {
  if (messageLike == null) return "No messages yet";
  if (typeof messageLike === "string") {
    const t = messageLike.trim();
    return t || "No messages yet";
  }
  const mt = String(messageLike.messageType || messageLike.type || "text").toLowerCase();
  const raw = messageLike.message ?? messageLike.content ?? messageLike.body ?? "";
  const content = typeof raw === "string" ? raw : "";
  if (["image", "imagecollage"].includes(mt)) return "Image";
  if (["video", "videocollage"].includes(mt)) return "Video";
  if (mt === "audio") return "Audio";
  if (mt === "document") return "Document";
  if (typeof content === "string" && /^https?:\/\//i.test(content.trim())) {
    const lower = content.toLowerCase();
    if (/\.(jpe?g|png|gif|webp)(\?|#|$)/i.test(lower)) return "Image";
    if (/\.(mp4|webm|mov)(\?|#|$)/i.test(lower)) return "Video";
    if (/\.(mp3|wav|ogg|m4a)(\?|#|$)/i.test(lower)) return "Audio";
    if (/\/(document|documents)\//i.test(lower) && /\.(bin|pdf|doc|docx|xls|xlsx|ppt|pptx|txt)(\?|#|$)/i.test(lower)) {
      return "Document";
    }
    if (/\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt)(\?|#|$)/i.test(lower)) return "Document";
    return "Attachment";
  }
  const words = String(content).trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "Message";
  const preview = words.slice(0, 3).join(" ");
  return words.length > 3 ? `${preview}...` : preview;
}
